import React, { useEffect, useState } from 'react';
import { Button, Tab, Tabs, FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import ImagePicker from '../../../../shared/ui-builder/image-picker/Image-Picker';
import RedirectSelector from '../../../../shared/ui-builder/redirect-selector/Redirect-Selector';
import CustomUiBuilderTextField from '../../../../shared/form-controls/custom-ui-builder-text-field/Custom-UI-Builder-Text-Field';
import {
  CAROUSEL_WO_BG,
  ICONS_STATUS_ACTIVE,
  ICONS_STATUS_INACTIVE,
} from '../../../../constants/UiBuilderConst';
import HotelModuleSelector from '../../../../shared/ui-builder/hotel-module-selector/Hotel-Module-Selector';
import ModuleIdSelector from '../../../../shared/ui-builder/module-id-selector/Module-Id-Selector';
import { Add } from '@material-ui/icons';
import { styled } from '@mui/material/styles';
import ViewAllSelector from '../../../../shared/ui-builder/view-all-selector/View-All-Selector';
import DraggableTabsList from '../../../../shared/draggable-tabs-list/Draggable-Tabs-List';
import MediaSelector from '../../../../shared/ui-builder/media-selector/Media-Selector';

const CustomTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
  textTransform: 'none',
}));

//2C Carousal No BKGD
const CarouselWithoutBackground = (props) => {
  const { onItemChange, config, groupId, handleError, componentNdx } = props;

  const initialSlide = [
    {
      id: `slide_1`,
      label: `Slide 1`,
      imgURL: null,
      titleH3: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
      icon: {
        iconList: [
          {
            imgURL: null,
            titleH4: '',
            isHide: false,
          },
          {
            imgURL: null,
            titleH4: '',
            isHide: false,
          },
        ],
      },
    },
    {
      id: `slide_2`,
      label: `Slide 2`,
      imgURL: null,
      titleH3: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
      icon: {
        iconList: [
          {
            imgURL: null,
            titleH4: '',
            isHide: false,
          },
          {
            imgURL: null,
            titleH4: '',
            isHide: false,
          },
        ],
      },
    },
    {
      id: `slide_3`,
      label: `Slide 3`,
      imgURL: null,
      titleH3: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
      icon: {
        iconList: [
          {
            imgURL: null,
            titleH4: '',
            isHide: false,
          },
          {
            imgURL: null,
            titleH4: '',
            isHide: false,
          },
        ],
      },
    },
    {
      id: `slide_4`,
      label: `Slide 4`,
      imgURL: null,
      titleH3: '',
      redirectLink: {
        connection: '',
        linkId: '',
        isActive: false,
      },
      shadowOverlay: false,
      loopPlayBack: false,
      isVideo: false,
      videoURL: null,
      icon: {
        iconList: [
          {
            imgURL: null,
            titleH4: '',
            isHide: false,
          },
          {
            imgURL: null,
            titleH4: '',
            isHide: false,
          },
        ],
      },
    },
  ];
  const addNewSlide = {
    id: '',
    label: '',
    imgURL: null,
    titleH3: '',
    redirectLink: {
      connection: '',
      linkId: '',
      isActive: false,
    },
    shadowOverlay: false,
    loopPlayBack: false,
    isVideo: false,
    videoURL: null,
    icon: {
      iconList: [
        {
          imgURL: null,
          titleH4: '',
          isHide: false,
        },
        {
          imgURL: null,
          titleH4: '',
          isHide: false,
        },
      ],
    },
  };
  const initialIconSlide = [
    {
      imgURL: null,
      titleH4: '',
      isHide: false,
    },
    {
      imgURL: null,
      titleH4: '',
      isHide: false,
    },
  ];
  const addNewIconSlide = {
    imgURL: null,
    titleH4: '',
    isHide: false,
  };
  const [slidesList, setSlidesList] = useState(
    config.slides && config.slides.length
      ? config.slides.map((e, index) => {
          return {
            ...e,
            id: `slide_${index + 1}`,
            label: `Slide ${index + 1}`,
          };
        })
      : initialSlide,
  );
  const [hotelModule, setHotelModule] = useState(config?.hotelModule || '');
  const [viewAll, setViewAll] = useState(
    config?.viewAll ? config.viewAll : { isActive: true, linkId: '' },
  );
  const [activeTabIndex, setActveTabIndex] = useState(0);
  const [activeTabContent, setActveTabContent] = useState(slidesList[0]);
  const [iconSlidesList, setIconSlidesList] = useState(
    slidesList[activeTabIndex]?.icon?.iconList || initialIconSlide,
  );
  const [h2Title, setH2Title] = useState(config.titleH2 || '');
  const [error, setError] = useState(null);
  const [hotelModuleName, setHotelModulename] = useState(config?.titleH2 || '');
  const [hotelSubModuleName, setHotelSubModuleName] = useState([]);
  const [statusValue, setStatusValue] = useState(
    config?.isIconActive ? ICONS_STATUS_ACTIVE : ICONS_STATUS_INACTIVE,
  );
  const [activeIconTabIndex, setActiveIconTabIndex] = useState(0);
  const [activeIconTabContent, setActiveIconTabContent] = useState(iconSlidesList[0]);
  const [isSwapEnabled, setIsSwapEnabled] = useState(false);
  const maxSlidesCount = 20;

  useEffect(() => {
    if (config.slides && config.slides.length) {
      const setHotelModule = config.slides.map((currSliderValue, ndx) => {
        return { index: ndx, name: currSliderValue.titleH3 };
      });
      setHotelSubModuleName(setHotelModule);
    }
  }, []);

  useEffect(() => {
    const currSlider = slidesList?.map((sliderValue, ndx) => {
      if (sliderValue.hotelModuleId && !sliderValue.titleH3) {
        const subModule = hotelSubModuleName.find((val) => val.index === ndx);
        return { ...sliderValue, titleH3: subModule?.name };
      }
      return { ...sliderValue };
    });
    onItemChange({
      componentName: CAROUSEL_WO_BG,
      config: {
        hotelModule: hotelModule,
        titleH2: h2Title || hotelModuleName,
        slides: currSlider.map(({ id, label, ...keepAttrs }) => keepAttrs),
        viewAll: viewAll,
        isIconActive: statusValue === ICONS_STATUS_ACTIVE ? true : false,
      },
    });
  }, [slidesList, h2Title, hotelModule, viewAll, statusValue, isSwapEnabled]);

  useEffect(() => {
    if (
      (slidesList && !slidesList[0]?.icon) ||
      (slidesList &&
        slidesList[0]?.icon &&
        slidesList[0]?.icon?.iconList &&
        !slidesList[0]?.icon?.iconList[0].hasOwnProperty('isHide'))
    ) {
      let tempSlideList = [...slidesList];
      const customizedList = tempSlideList?.map((sliderValue, ndx) => {
        return {
          ...sliderValue,
          icon: {
            iconList: [
              {
                imgURL: null,
                titleH4: '',
                isHide: false,
              },
              {
                imgURL: null,
                titleH4: '',
                isHide: false,
              },
            ],
          },
        };
      });
      setSlidesList(customizedList);
      setActveTabContent(customizedList[0]);
      setActiveIconTabContent(customizedList[0]?.icon?.iconList[0]);
    }
  }, [slidesList]);

  useEffect(() => {
    if (handleError && handleError.length > 0) {
      setIsSwapEnabled(false);
      const currError = handleError.find(
        (getError) => getError.pos === componentNdx && getError.id === CAROUSEL_WO_BG,
      );
      if (currError && currError.slides.length > 0) {
        const sliderNdx = Math.min.apply(
          Math,
          currError.slides.map((o) => o.pos),
        );

        const filterIconErrors = currError?.slides.find((o) => o.pos === sliderNdx)?.icon;
        if (filterIconErrors?.length > 0) {
          const iconSliderNdx = Math.min.apply(
            Math,
            filterIconErrors.map((o) => o.pos),
          );
          setActiveIconTabIndex(iconSliderNdx);
          setActiveIconTabContent(slidesList[sliderNdx]?.icon?.iconList[iconSliderNdx]);
        }
        setActveTabIndex(sliderNdx);
        setActveTabContent(slidesList[sliderNdx]);
        setError(currError ?? null);
      }
    }
  }, [handleError]);

  const setErrorField = (field, val) => {
    if (field !== 'redirect') {
      const trimmed = typeof val === 'string' ? val?.trim() : val;
      return trimmed ? '' : 'required';
    }
    if (val?.type) return '';
    return 'required';
  };

  const handleTabData = (val, slideContent, field, moduleName) => {
    const fieldErr = setErrorField(field, val);
    const newSlidesErr = slidesList?.map((_, idx) => {
      const prev = error?.slides?.find((e) => e?.pos === idx) || { pos: idx };
      return idx === activeTabIndex
        ? { ...prev, [field === 'iconImgUrl' ? 'imgURL' : field]: fieldErr }
        : prev;
    });
    setError({ ...error, slides: newSlidesErr });
    switch (field) {
      case 'titleH3':
        slideContent.titleH3 = val;
        break;
      case 'imgURL':
        slideContent.imgURL = val;
        break;
      case 'redirect':
        slideContent.redirectLink.connection = val.type;
        slideContent.redirectLink.linkId = val.value;
        break;
      case 'isActive':
        slideContent.redirectLink.isActive = val;
        break;
      case 'hotelModuleId':
        slideContent.hotelModuleId = val ? val : '';
        slideContent.titleH3 = moduleName ? moduleName : '';
        const currentsubModuleName = [...hotelSubModuleName];
        const checkExistingModuleNdx = currentsubModuleName.findIndex(
          (moduleValue) => moduleValue.index === activeTabIndex,
        );
        if (checkExistingModuleNdx > -1) {
          currentsubModuleName[checkExistingModuleNdx].name = moduleName;
        } else {
          currentsubModuleName.push({
            index: activeTabIndex,
            name: moduleName,
          });
        }
        setHotelSubModuleName(currentsubModuleName);
        break;
      case 'isVideo':
        slideContent.isVideo = val;
        break;
      case 'shadowOverlay':
        slideContent.shadowOverlay = val;
        break;
      case 'videoURL':
        slideContent.videoURL = val;
        break;
      case 'loopPlayBack':
        slideContent.loopPlayBack = val;
        break;
      case 'viewAll':
        setViewAll({
          ...viewAll,
          linkId: val,
        });
        break;
      case 'viewAllStatus':
        setViewAll({
          ...viewAll,
          isActive: val,
        });
        break;
      case 'titleH4':
        slideContent.icon.iconList[activeIconTabIndex].titleH4 = val;
        break;
      case 'iconImgUrl':
        slideContent.icon.iconList[activeIconTabIndex].imgURL = val;
        break;
      case 'isHideIcon':
        slideContent.icon.iconList[activeIconTabIndex].isHide = val;
        break;
      default:
        break;
    }
    setSlidesList(
      slidesList.map((slide, index) => {
        if (index === activeTabIndex) {
          return slideContent;
        } else {
          return slide;
        }
      }),
    );
  };

  const onTabChange = (e, value) => {
    setActveTabIndex(value);
    setActveTabContent(slidesList[value]);
    setActiveIconTabIndex(0);
    setActiveIconTabContent(slidesList[value]?.icon?.iconList[0]);
  };

  const onIconTabChange = (e, value) => {
    setActiveIconTabIndex(value);
    setActiveIconTabContent(activeTabContent?.icon?.iconList[value]);
  };

  const onChangeH1 = (val) => {
    const cfgErr = setErrorField('titleH2', val);
    setError({
      ...error,
      config: { ...error?.config, titleH2: cfgErr },
    });
    setH2Title(val);
  };

  const hasError = (key, isReturnString = false) => {
    const hasSliderError = error?.slides?.find((errorSlider) => {
      if (key === 'titleH4' || key === 'iconImgUrl') {
        const tempKey = key === 'iconImgUrl' ? 'imgURL' : key;
        const filteredIcons = errorSlider?.icon?.filter((x) => x !== undefined);
        if (filteredIcons?.length > 0) {
          return filteredIcons.find(
            (iconSlider) =>
              iconSlider.pos === activeIconTabIndex && iconSlider[tempKey] === 'required',
          );
        }
        return false;
      } else {
        return (
          errorSlider.pos === activeTabIndex &&
          (errorSlider[key] === 'required' || errorSlider[key] === 'validUrl')
        );
      }
    });
    if (isReturnString && hasSliderError) return hasSliderError?.videoURL;
    if (hasSliderError) return true;
    return false;
  };

  const onChangeHotelModule = (val, moduleName) => {
    setHotelModule(val || '');
    onChangeH1(moduleName || '');
    setHotelModulename(moduleName || '');
    setHotelSubModuleName([]);
    const tempSlidesList = slidesList.map((slide) => {
      return { ...slide, hotelModuleId: '', titleH3: '' };
    });
    setSlidesList(tempSlidesList);
    setActveTabContent(tempSlidesList[activeTabIndex]);
  };

  const AddNewSlide = (e) => {
    if (slidesList.length < maxSlidesCount) {
      setActiveIconTabIndex(0);
      const tempSlidesList = [...slidesList];
      addNewSlide.id = `slide_${slidesList.length + 1}`;
      addNewSlide.label = `Slide ${slidesList.length + 1}`;
      tempSlidesList.push(addNewSlide);
      setSlidesList(tempSlidesList);
      setActiveIconTabContent(tempSlidesList[tempSlidesList.length - 1].icon?.iconList[0]);
      setActveTabIndex(tempSlidesList.length - 1);
      setActveTabContent(tempSlidesList[tempSlidesList.length - 1]);
    }
  };

  const removeSlide = (e) => {
    if (slidesList.length > 1) {
      setActiveIconTabIndex(0);
      const tempSlidesList = [...slidesList];
      tempSlidesList.splice(activeTabIndex, 1);
      setSlidesList(tempSlidesList);
      if (activeTabIndex === tempSlidesList.length) {
        setActveTabIndex(tempSlidesList.length - 1);
        setActveTabContent(tempSlidesList[tempSlidesList.length - 1]);
        setActiveIconTabContent(tempSlidesList[tempSlidesList.length - 1].icon?.iconList[0]);
      } else {
        setActveTabContent(tempSlidesList[activeTabIndex]);
        setActiveIconTabContent(tempSlidesList[activeTabIndex].icon?.iconList[0]);
      }
    }
  };

  const onStatusChange = (e) => {
    setStatusValue(e.target.value);
  };

  const AddNewIconSlide = (e) => {
    if (iconSlidesList.length < maxSlidesCount) {
      const tempSlidesList = [...slidesList];
      tempSlidesList[activeTabIndex].icon.iconList = [
        ...tempSlidesList[activeTabIndex].icon.iconList,
        addNewIconSlide,
      ];
      setSlidesList(tempSlidesList);
      const tempIconSlidesList = [...iconSlidesList];
      tempIconSlidesList.push(addNewIconSlide);
      setIconSlidesList(tempIconSlidesList);
      setActiveIconTabIndex(tempIconSlidesList.length - 1);
      setActiveIconTabContent(tempIconSlidesList[tempIconSlidesList.length - 1]);
    }
  };

  const hideIconSlide = (e) => {
    handleTabData(!activeIconTabContent.isHide, activeTabContent, 'isHideIcon');
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const newTabs = slidesList;
    const draggedTab = newTabs.splice(result.source.index, 1)[0];
    newTabs.splice(result.destination.index, 0, draggedTab);
    setActveTabIndex(result.destination.index);
    setActveTabContent(draggedTab);
    setSlidesList(newTabs);
    setIsSwapEnabled(true);
    const currSlider = slidesList?.map((sliderValue, ndx) => {
      if (sliderValue.hotelModuleId && !sliderValue.titleH3) {
        const subModule = hotelSubModuleName.find((val) => val.index === ndx);
        return { ...sliderValue, titleH3: subModule?.name };
      }
      return { ...sliderValue };
    });
    onItemChange({
      componentName: CAROUSEL_WO_BG,
      config: {
        hotelModule: hotelModule,
        titleH2: h2Title || hotelModuleName,
        slides: currSlider.map(({ id, label, ...keepAttrs }) => keepAttrs),
        viewAll: viewAll,
        isIconActive: statusValue === ICONS_STATUS_ACTIVE ? true : false,
      },
    });
  };

  return (
    <div className='row my-2 mx-4'>
      <div className='col-md-10'>
        <div className='col-md-12 mb-3'>
          <HotelModuleSelector
            hotelModule={hotelModule}
            onChangeHotelModule={(e, moduleName) => onChangeHotelModule(e, moduleName)}
          />
        </div>
        <CustomUiBuilderTextField
          label='H2 Title'
          required={!Boolean(hotelModule)}
          className='col-md-12'
          value={h2Title}
          onChangeInput={(e) => onChangeH1(e.target.value)}
          maxLength={100}
          isAdornment={true}
          endAdornment={true}
          error={
            !isSwapEnabled && !hotelModule && error?.config?.titleH2 === 'required' ? true : false
          }
        />
        <div className='row align-items-center mb-4 mt-3'>
          <div className='col-md-4 title'>Icons</div>

          <div className='col-md-8'>
            <RadioGroup
              row
              aria-label='statusValue'
              onChange={onStatusChange}
              value={statusValue}
              className='document-type'
              name='row-radio-buttons-group'
            >
              <FormControlLabel
                value={ICONS_STATUS_INACTIVE}
                control={<Radio color='primary' />}
                label='Inactive'
                className='me-5'
              />
              <FormControlLabel
                value={ICONS_STATUS_ACTIVE}
                control={<Radio color='primary' />}
                label='Active'
              />
            </RadioGroup>
          </div>
        </div>
        <div className='row mt-4 mb-3'>
          <div className='col-md-12 slide-tabs d-flex horizontal-scroll-styled pb-2'>
            <DraggableTabsList
              onDragEnd={onDragEnd}
              tabs={slidesList}
              onTabChange={onTabChange}
              activeTabIndex={activeTabIndex}
            />
            <div className='ms-2'>
              <Button
                disabled={slidesList.length >= maxSlidesCount}
                variant='outlined'
                size='medium'
                color='secondary'
                onClick={(e) => AddNewSlide(e)}
              >
                <Add />
              </Button>
            </div>
          </div>
          <div className='col-md-12 mt-3'>
            <div className='d-flex justify-content-between px-3 py-2 remove-slide-div'>
              <div>Slide {activeTabContent?.id?.split('_')[1]}</div>
              <div className='text-underlined pointer' onClick={(e) => removeSlide(e)}>
                Remove
              </div>
            </div>
            {hotelModule && (
              <div className='col-md-12'>
                <ModuleIdSelector
                  key={activeTabContent?.id}
                  hotelModule={hotelModule}
                  hotelModuleId={activeTabContent.hotelModuleId}
                  onChangeHotelModuleId={(e, moduleName) =>
                    handleTabData(e.target.value, activeTabContent, 'hotelModuleId', moduleName)
                  }
                />
              </div>
            )}
            <div className='col-md-12'>
              <CustomUiBuilderTextField
                label='H3 Title'
                required={!Boolean(activeTabContent.hotelModuleId)}
                className='col-md-12 mt-3'
                value={activeTabContent.titleH3}
                onChangeInput={(e) => handleTabData(e.target.value, activeTabContent, 'titleH3')}
                maxLength={100}
                isAdornment={true}
                endAdornment={true}
                error={
                  activeTabContent.hotelModuleId ? false : !isSwapEnabled && hasError('titleH3')
                }
              />
              <div className='col-md-12 mt-4'>
                <MediaSelector
                  groupId={groupId}
                  titleH2={'Image'}
                  height={220}
                  width={330}
                  matrix={'px'}
                  handleTabData={handleTabData}
                  activeTabContent={activeTabContent}
                  isSwapEnabled={isSwapEnabled}
                  hasError={hasError}
                  setIsSwapEnabled={setIsSwapEnabled}
                  ratio={'3:2'}
                />
              </div>
              {statusValue === ICONS_STATUS_ACTIVE && (
                <div className='row mt-4 mb-3'>
                  <div className='col-md-12 slide-tabs d-flex horizontal-scroll-styled pb-2'>
                    <Tabs
                      value={activeIconTabIndex}
                      variant='fullWidth'
                      indicatorColor='primary'
                      onChange={onIconTabChange}
                      aria-label='tabs'
                      textColor='primary'
                    >
                      {activeTabContent?.icon?.iconList?.map((slide, index) => (
                        <CustomTab key={index} label={`Icon ${index + 1}`} />
                      ))}
                    </Tabs>
                    <div className='ms-2'>
                      <Button
                        disabled={activeTabContent?.icon?.iconList?.length >= maxSlidesCount}
                        variant='outlined'
                        size='medium'
                        color='secondary'
                        onClick={(e) => AddNewIconSlide(e)}
                      >
                        <Add />
                      </Button>
                    </div>
                  </div>
                </div>
              )}
              {statusValue === ICONS_STATUS_ACTIVE && (
                <div className='col-md-12 mt-3'>
                  <div className='d-flex justify-content-between px-3 py-2 remove-slide-div'>
                    <div>Icon {activeIconTabIndex + 1}</div>
                    <div className='text-underlined pointer' onClick={(e) => hideIconSlide(e)}>
                      {!activeIconTabContent?.isHide ? 'Hide' : 'Show'}
                    </div>
                  </div>
                  {!activeIconTabContent.isHide && (
                    <div>
                      <CustomUiBuilderTextField
                        label='H4 Title'
                        required={true}
                        className='col-md-12 mt-3'
                        value={activeIconTabContent.titleH4}
                        onChangeInput={(e) =>
                          handleTabData(e.target.value, activeTabContent, 'titleH4')
                        }
                        maxLength={50}
                        isAdornment={true}
                        endAdornment={true}
                        error={!isSwapEnabled && hasError('titleH4')}
                      />
                      <div className='mt-4'>
                        <ImagePicker
                          key={`cwb-icon-${activeTabIndex}-${activeIconTabIndex}`}
                          groupId={groupId}
                          title={'Icon'}
                          ratio={'1:1'}
                          height={24}
                          width={24}
                          matrix={'px'}
                          onImageSelect={(e) => handleTabData(e, activeTabContent, 'iconImgUrl')}
                          imgURL={activeIconTabContent.imgURL}
                          error={!isSwapEnabled && hasError('iconImgUrl')}
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
              <div className='col-md-12 mt-4'>
                <RedirectSelector
                  onValueChange={(e) => handleTabData(e, activeTabContent, 'redirect')}
                  redirectType={activeTabContent.redirectLink.connection}
                  value={activeTabContent.redirectLink.linkId}
                  onRedirectChange={(e) => {
                    handleTabData(e, activeTabContent, 'isActive');
                  }}
                  isActive={activeTabContent.redirectLink.isActive}
                  error={!isSwapEnabled && hasError('redirect')}
                />
              </div>
              <div className='col-md-12 mt-4'>
                <ViewAllSelector
                  onValueChange={(e) => handleTabData(e, activeTabContent, 'viewAll')}
                  value={viewAll.linkId}
                  onViewAllStatusChange={(e) => {
                    handleTabData(e, activeTabContent, 'viewAllStatus');
                  }}
                  isActive={viewAll.isActive}
                  isRequired={viewAll.isActive ? true : false}
                  error={
                    !isSwapEnabled && viewAll.linkId === '' && error?.config?.viewAll === 'required'
                  }
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CarouselWithoutBackground;
